import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mario } from "../characters/Mario";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doPhoneRing, doWaitImageByTime, isAnnGF, isAnnGFAndCorrupted, isJoeEnemy, isMCCheated } from "../helpers/helpers";
import { images } from "./images";
import { V7VanessaOutsideConvAfter } from "./V7";
import { V8VanessaJoeMCThreesome_DontGrabVanessa } from "./V8_VanessaJoeMCUnderpass";

export const V7VanessaOutsideConv = async (): Promise<any> => {
    doWaitImageByTime(images.v7.V7VanessaOutsideConv_1, null, 2);
    if (isJoeEnemy()) {

        mc.think(`Vanessa...?\nWhat is she doing here?`);

    } else {
        mc.think(`I can't believe Joey is really going to break up with Vanessa.`);
        if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {


        } else {
            mc.think(`But he might change his mind after our conversation starts sinking in. `);
        }
        mc.think(`Speaking of the devil...?\nWhat is she doing here?`);
    }

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_2);
    mc.talk(`Are you waiting for me?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_2_2);
    vanessa.talk(`Finally.`);
    mc.talk(`Is there a reason why you look upset?`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4, { duration: 1 });
    vanessa.talk(`Where have you been?`);

    if (isJoeEnemy()) {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`Hello to you to.`);
        mc.talk(`What are you doing here anyway?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
        vanessa.talk(`Answer!`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`I was just going for a walk... Why?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_5);
        vanessa.talk(`I just got a text from Joey.`);
    } else {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`Hello to you to.`);
        mc.talk(`What are you doing here anyway?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
        vanessa.talk(`Answer!`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`I was at the gym with Joe, why?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_5);
        vanessa.talk(`I just got a text from him.`);
    }

    vanessa.talk(`He said that we need to "talk".`);
    vanessa.talk(`Do you know anything about that?`);
    if (isJoeEnemy()) {
        mc.talk(`Why would I? You know I don't talk to him anymore.`);
    } else {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
        vanessa.talk(`Don't tell me it's your doing!`);

    }
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`Why are you so sure it's something bad?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_6, { duration: 0.7 });
    vanessa.talk(`${mc.name}, at this point I'm starting to feel bad calling you stupid every time we meet.`);
    vanessa.talk(`So let's forget about your last comment.`);
    if (isJoeEnemy()) {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`I have no idea what are you talking about.`);
        mc.talk(`But if I had to make an estimated guess I would say he is dumping you.`);

    } else {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4, { duration: 0.7 });
        vanessa.talk(`Now. Let me ask again.`);
        vanessa.talk(`Did you convince him that we should have a "talk".`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`It's between you two...`);
        mc.talk(`All I can say is that I had nothing to do with this.`);
        mc.talk(`I just listened to what he had to say.`);
        mc.talk(`And don't try to get anything else out of me.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
        vanessa.talk(`Fine! It's not like I care anyway.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`You don't look like someone who doesn't care.`);

    }

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
    vanessa.talk(`I don't get dumped! I do the dumping!`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`Why does it matter anyway?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
    vanessa.talk(`I need to keep my record clean.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`That's all it is for you? A lousy record?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
    vanessa.talk(`Of course.`);
    vanessa.talk(`I didn't want this relationship in the first place.`);

    vanessa.talk(`I kept telling him he would regret it.`);
    vanessa.talk(`And now he goes all dramatic on me.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_6);
    vanessa.talk(`Shit.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`Why did you agree to try it in the first place?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);

    vanessa.talk(`Try what? To be his girlfriend?`);
    vanessa.talk(`I don't know, he just convinced me.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    vanessa.talk(`He kept wanting me to love him.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`I told him the only person I'll ever love is myself.`);
    vanessa.talk(`He said he could change me.`);
    vanessa.talk(`Pff. Yeah right.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    // FIXME: change this so it will be more clear what the bet is -> if agreeing that means cheating on Ann if GF
    // remove this question and have Vanessa saying she is perfect and then make a bet question 
    await vanessa.setQuestion(new Question({ text: `Why change me to begin with? I'm perfect!`, options: { think: false }, key: `v7VanessaConvAgreeSheIsPerfect` })
        .option({ title: `Agree`, key: true })
        .option({ title: `disagree`, key: false }));


    if (Question.globalAnswers.v7VanessaConvAgreeSheIsPerfect) {
        return jump(V7VanessaOutsideConv_AgreeVanessaPerfect, "V7VanessaOutsideConv_AgreeVanessaPerfect");


    } else {
        return jump(V7VanessaOutsideConv_DoesntAgreeVanessaPerfect, "V7VanessaOutsideConv_DoesntAgreeVanessaPerfect");


    }

};
export const V7VanessaOutsideConv_AgreeVanessaPerfect = async (): Promise<any> => {
    mc.talk(`I agree...`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_11);
    vanessa.talk(`Like duh!`);
    mc.talk(`It's always nice giving you compliments.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    vanessa.talk(`You should be more like me.`);
    mc.talk(`Have you lost your mind?`);
    mc.talk(`I prefer not having STD's...`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`I've never had a STD.`);
    mc.talk(`...`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    vanessa.talk(`Twice in a row...`);
    mc.talk(`Makes sense.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_6);
    vanessa.talk(`What the fuck! That was a joke.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
    vanessa.talk(`Do you actually believe I got infected with that shit?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`I know how to pick my men.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`If he has a pulse that's good enough, right?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    vanessa.talk(`It depends. If he doesn't, I can still compromise if the body is warm enough.`);

    mc.talk(`I know you are cynical, but somehow I believe you.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`I was being serious by the way.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`About fucking a body?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_6);
    vanessa.talk(`No...`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`That you can be a great male version of me.`);
    vanessa.talk(`I saw your potential when I first met you.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
    vanessa.talk(`I can give you a course if you want.`);
    mc.talk(`Isn't it just go around and cause chaos wherever I go?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
    vanessa.talk(`Of course not!`);
    vanessa.talk(`And what the fuck? I don't cause chaos.`);
    vanessa.talk(`I bring light when I enter a room.`);
    mc.talk(`If you hold a candle...`);

    vanessa.talk(`Who is the cynic now?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
    mc.talk(`Haha, I'm just joking.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_13);
    vanessa.talk(`But seriously! What do you say?`);
    mc.talk(`Me becoming you?`);
    mc.talk(`I don't know about that.`);
    if (isAnnGFAndCorrupted()) {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
        vanessa.talk(`You already turned Ann into a slut, so why not become one?`);
        mc.talk(`I'm not turning myself into a male slut...`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
        vanessa.talk(`Come on, you know what I mean.`);

    } else {

    }
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    vanessa.talk(`You already agreed that I'm perfect so what are you scared of?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
    vanessa.talk(`Let me show you the light.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`If you don't like it, I'll then follow your lead!`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
    mc.talk(`That sounds tempting...`);
    if (isAnnGF()) {
        mc.talk(`Does that means I'll have to cheat on Ann?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        vanessa.talk(`Of course.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
        mc.talk(`Mmm...`);
        if (isMCCheated()) {
            mc.think(`I already cheated on her anyway...`);
        }
    }
    await vanessa.setQuestion(new Question({ text: `Is that a yes?`, options: { think: false }, key: `v7VanessaConvAgreeToVanessaBet` })
        .option({ title: `Agree`, key: true })
        .option({ title: `disagree`, key: false }));

    if (Question.globalAnswers.v7VanessaConvAgreeToVanessaBet) {

        mc.talk(`Alright.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        vanessa.talk(`Oh boy! This is going to be fun!`);
    } else {
        mc.talk(`Nah... I don't feel good about that. I'll pass.`);
        return jump(V7VanessaOutsideConv_DoesntAgreeVanessaPerfect, "V7VanessaOutsideConv_DoesntAgreeVanessaPerfect");

    }

    if (mc.properties.wantVanessaAsGF) {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        mc.think(`I've already made up my mind that I want Vanessa.`);
        mc.think(`And I think she is amazing the way she is.`);
        mc.think(`But do I really want to be like her?`);
        mc.think(`And it's not like she's gonna change me in one day.`);
        mc.think(`I don't know... It might be fun.`);

    } else if (Question.globalAnswers.v7JoeGymToldBreakupVanessa === false) {

    }
    return jump(V7VanessaOutsideConv_Continue, "V7VanessaOutsideConv_Continue");
};
export const V7VanessaOutsideConv_DoesntAgreeVanessaPerfect = async (): Promise<any> => {
    if (Question.globalAnswers.v7VanessaConvAgreeToVanessaBet === false) {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_6);
        vanessa.talk(`Fuck!`);
        mc.talk(`Did I ruin your plans?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_9);
        vanessa.talk(`A little...`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
        mc.talk(`Mmm...`);
        mc.talk(`You know what?`);
        mc.talk(`I'll agree to it only if I go first!`);
        mc.talk(`You will follow my lead, and if I'll turn into a male version of you.`);

    } else {

        mc.talk(`I find it hard to agree.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
        vanessa.talk(`Are you serious?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`You have your moments, but you don't care about other people's feelings.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_6);
        vanessa.talk(`You don't know what you are talking about.`);

        mc.talk(`Most people won't let the things you do slide.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_3);
        mc.talk(`Besides Ann, how many friend have you got?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
        vanessa.talk(`Plenty.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
        mc.talk(`Name one who is not Ann.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        vanessa.talk(`Your mom.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
        mc.talk(`That's very mature.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
        vanessa.talk(`Just get to the point.`);

        ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
        mc.talk(`I've learned a lot about you by now.`);
        mc.talk(`It's true that you are fun to be around, but sometimes it's too much.`);
        mc.talk(`You need to find a balance.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_11);
        vanessa.talk(`Oh yeah? And who is going to teach me? YOU?`);

        ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
        mc.talk(`Why not?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        vanessa.talk(`Haha!`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
        vanessa.talk(`Thank you! I knew you'd cheer me up!`);

        vanessa.talk(`Let's talk hypothetically.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        vanessa.talk(`Leeet's say that I agreed.`);
        vanessa.talk(`And leeet's say that I listen to what you got to offer.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_13);
        vanessa.talk(`What's in it for me?`);

        mc.talk(`Being a better person isn't enough?`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
        vanessa.talk(`No, because I'm already a better person than you.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
        vanessa.talk(`Try harder.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
        mc.talk(`Mmm...`);
        mc.talk(`You know what? If you'll agree to do this and I fail, I'll follow your lead.`);
        mc.talk(`I'll turn into a male version of you.`);
    }

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    vanessa.talk(`OH MY GOD!`);
    vanessa.talk(`I'm in! When can we start?! Let's start now!`);
    mc.talk(`Relax, I need to plan what I'm going to do with you first.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_11);
    vanessa.talk(`You are so bad at this.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
    vanessa.talk(`I already know what I'm going to do with you!`);
    vanessa.talk(`Oh boy... The things I'll plan for you.`);
    mc.talk(`By the way, one of the ground rules is that you can't fail on purpose.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_9);
    vanessa.talk(`Fuck!`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_13);
    vanessa.talk(`Don't worry, I'm a lot of things, but I don't cheat...`);
    mc.talk(`...`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_11);
    vanessa.talk(`On bets!`);
    mc.talk(`If you cheat, the bet is off.`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
    vanessa.talk(`Deal!`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
    if (mc.properties.wantVanessaAsGF) {
        mc.think(`I've already made up my mind that I want Vanessa.`);
        mc.think(`This can be an amazing opportunity for me.`);
        mc.think(`If I manage to change her a bit maybe I can make it work...`);
        mc.think(`But then again, it could backfire on me like it did on Joey.`);
        mc.think(`Either way, it's going to be an adventure.`);

    } else if (Question.globalAnswers.v7JoeGymToldBreakupVanessa === false) {
        mc.think(`I've convinced Joey to stay with her.`);
        mc.think(`If I could make her change, just a little, it could save their relationship.`);
        mc.think(`And if it fails. At least I know I tried.`);


    }
    return jump(V7VanessaOutsideConv_Continue, "V7VanessaOutsideConv_Continue");
};

export const V7VanessaOutsideConv_Continue = async (): Promise<any> => {
    doPhoneRing();;
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_14, { duration: 1 });
    vanessa.talk(`Who is it?`);
    mc.talk(`Unknown number.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_15, { duration: 1 });
    mc.talk(`Hello?`, { method: "On Phone" });

    mario.talk(`This is Mario. You have my suit.`, { method: "Over Phone" });
    mc.talk(`Do you mean the outfit?`, { method: "On Phone" });
    mario.talk(`Yes that.`, { method: "Over Phone" });
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_15_2, { duration: 1 });
    mc.talk(`Shit I totally forgot about that.`, { method: "Whispering" });
    if (mc.properties.annStatus === "gf") {
        vanessa.talk(`Did you get Ann to try it out?`, { method: "Whispering" });
        if (ann.properties.isCorrupted) {
            mc.talk(`I have.`);
            vanessa.talk(`Really? Why didn't you tell me!`);
            mc.talk(`You didn't mention it.`);
            mario.talk(`HELLO???`, { method: "Over Phone" });
        } else {
            if (!Game.seenScenarios.includes(`V7AnnPure`)) {
                mc.talk(`No! I was too busy being with you the whole day.`, { method: "Whispering" });
                vanessa.talk(`Fuck!`, { method: "Whispering" });
            } else {
                mc.talk(`No...`);
                vanessa.talk(`Fuck!`, { method: "Whispering" });
                mc.talk(`I wanted to meet with her yesterday but she had to study and --.`, { method: "Whispering" });
                vanessa.talk(`Jeez, Relax. I don't need your whole life story.`, { method: "Whispering" });
            }
        }

    } else {
        mc.talk(`Let's go get it back to him.`, { method: "Whispering" });
        vanessa.talk(`No wait. I want Ann to try it out first.`, { method: "Whispering" });
        mario.talk(`HELLO???`, { method: "Over Phone" });

    }

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_15);
    vanessa.talk(`Hello! This is Vanessa!`, { method: "On Phone" });
    mario.talk(`Ha...Ha... I remember you.`, { method: "Over Phone" });
    vanessa.talk(`Of course you do!`, { method: "On Phone" });
    if (isAnnGF() && ann.properties.isCorrupted) {
        vanessa.talk(`Text us the address, we'll be right there!`, { method: "On Phone" });
        mario.talk(`Bye.`, { method: "Over Phone" });
        return jump(V7VanessaOutsideConvAfter, "V7VanessaOutsideConvAfter");
    } else {

        vanessa.talk(`Listen! We said a few days.`, { method: "On Phone" });
        mario.talk(`I need it today.`, { method: "Over Phone" });
        vanessa.talk(`Can we have a couple of hours at least?`, { method: "On Phone" });
        mario.talk(`Couple of hours. I'll text you the address.`, { method: "Over Phone" });
    }
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_8, { duration: 1 });
    mc.talk(`Why didn't you work your magic on him like you did previously?`);
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    vanessa.talk(`It's hard to do it over the phone...`);
    vanessa.talk(`Anyway, we got a couple of hours, I don't think we'll need more than that.`);
    vanessa.talk(`Let's just meet Ann quick.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
    mc.talk(`Is it really that important that she tries it on?`);
    if (mc.properties.annStatus === "gf") {

        mc.talk(`I didn't even mention it to her.`);
    } else {

    }
    mc.talk(`We can just bring it back to Mario right now.`);

    ImageClass.setImage(images.v7.V7VanessaOutsideConv_7);
    if (mc.properties.annStatus === "gf") {
        vanessa.talk(`It's important.`);
        vanessa.talk(`She asked me to help her with your relationship.`);
        vanessa.talk(`She promised that she'll do everything that is necessary.`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
        vanessa.talk(`So no, I'm not wasting this opportunity!`);
        mc.talk(`It's just an outfit...`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_12);
        vanessa.talk(`A SEXY outfit!`);
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_10);
        vanessa.talk(`That she needs to wear to understand she can be sexy if SHE wants to.`);
        if (Question.globalAnswers.v7VanessaConvAgreeSheIsPerfect) {
            mc.talk(`It sounds like you did to her what you are trying to do to me.`);
            mc.talk(`You just like to control people don't you?`);

        }



    } else {
        ImageClass.setImage(images.v7.V7VanessaOutsideConv_8);
        ann.talk(`It's girls stuff; you would never understand.`);
        mc.talk(`If you say so.`);
    }
    ImageClass.setImage(images.v7.V7VanessaOutsideConv_4);
    vanessa.talk(`Stop wasting time! Let's go!`);
    return jump(V7VanessaOutsideConvAfter, "V7VanessaOutsideConvAfter");
};